import api from 'plugin/api';
import { API_URL } from 'types/const';
import format from 'utils/string/format';

/**
 * 질문 및 답변 목록 조회
 * @param {Object} params 요청 데이터
 * @param {string} params.keyword 제목 / 등록자
 * @param {number} [params.page=0] 페이지
 * @param {number} [params.size=20] 페이지당 최대 데이터 수
 * @return {Object} 응답 데이터
 */
async function requestList(params) {
  return api.get(API_URL.board.qna.default, { params });
}

/**
 * 질문 등록
 * @param {Object} data 요청 데이터
 * @param {string} data.title 제목
 * @param {string} data.content 내용
 * @return {Object} 응답 데이터
 */
async function requestInsert(data) {
  return api.post(API_URL.board.qna.default, data);
}

/**
 * 질문 수정
 * @param {number} seq 질문 번호
 * @param {Object} data 요청 데이터
 * @param {string} data.title 제목
 * @param {string} data.content 내용
 * @return {Object} 응답 데이터
 */
async function requestUpdate(seq, data) {
  return api.put(format(API_URL.board.qna.inform, { seq }), data);
}

/**
 * 질문 삭제
 * @param {number} seq 질문 번호
 * @return {Object} 응답 데이터
 */
async function requestDelete(seq) {
  return api.delete(format(API_URL.board.qna.inform, { seq }));
}

/**
 * 질문 및 답변 정보 조회
 * @param {number} seq 질문 번호
 * @return {Object} 응답 데이터
 */
async function requestInform(seq) {
  return api.get(format(API_URL.board.qna.inform, { seq }));
}

/**
 * 답변 등록
 * @param {number} seq 질문 번호
 * @param {Object} data 요청 데이터
 * @param {string} data.comment 답변
 * @return {Object} 응답 데이터
 */
async function requestCommentInsert(seq, data) {
  return api.post(format(API_URL.board.qna.comment.insert, { seq }), data);
}

/**
 * 답변 수정
 * @param {number} seq 답변 번호
 * @param {Object} data 요청 데이터
 * @param {string} data.comment 답변
 * @return {Object} 응답 데이터
 */
async function requestCommentUpdate(seq, data) {
  return api.put(format(API_URL.board.qna.comment.update, { seq }), data);
}

/**
 * 답변 삭제
 * @param {number} seq 답변 번호
 * @return {Object} 응답 데이터
 */
async function requestCommentDelete(seq) {
  return api.delete(format(API_URL.board.qna.comment.update, { seq }));
}

export {
  requestList,
  requestInsert,
  requestUpdate,
  requestDelete,
  requestInform,
  requestCommentInsert,
  requestCommentUpdate,
  requestCommentDelete
};
